/** i18n piatto pattern Sequo. IT/EN dal giorno 1, default EN (portali internazionali). */

export type Lang = 'en' | 'it';

const STORAGE_KEY = 'tilt:lang';

const dict = {
  'tagline': { en: 'Roll. Hold. Push your luck.', it: 'Lancia. Tieni. Sfida la sorte.' },
  'action.roll': { en: 'ROLL', it: 'LANCIA' },
  'action.reroll': { en: 'REROLL ({n})', it: 'RILANCIA ({n})' },
  'action.bank': { en: 'BANK IT', it: 'INCASSA' },
  'action.again': { en: 'ONE MORE ROLL', it: 'ANCORA UNA' },
  'hint.hold': { en: 'Tap dice to hold them', it: 'Tocca i dadi per tenerli' },
  'hint.rollsLeft': { en: 'rerolls left', it: 'rilanci rimasti' },
  'score.chips': { en: 'Chips', it: 'Chips' },
  'score.mult': { en: 'Mult', it: 'Molt.' },
  'score.total': { en: 'Score', it: 'Punti' },
  'combo.pair': { en: 'Pair', it: 'Coppia' },
  'combo.two-pair': { en: 'Two Pair', it: 'Doppia Coppia' },
  'combo.three-kind': { en: 'Trips', it: 'Tris' },
  'combo.full-house': { en: 'Full House', it: 'Full' },
  'combo.small-straight': { en: 'Mini Run', it: 'Scala Corta' },
  'combo.large-straight': { en: 'Big Run', it: 'Scala Lunga' },
  'combo.four-kind': { en: 'Quad Squad', it: 'Poker' },
  'combo.five-kind': { en: 'QUINTS!', it: 'QUINTETTO!' },
  'combo.six-kind': { en: 'THE SESTETTO', it: 'SESTETTO' },
  'combo.chance': { en: 'Loose Change', it: 'Somma Secca' },
  'footer.sprint0': {
    en: 'Sprint 0 prototype — talismans, TILT bar & the full run are coming.',
    it: 'Prototipo Sprint 0 — talismani, barra TILT e la run completa in arrivo.',
  },
} satisfies Record<string, Record<Lang, string>>;

export type I18nKey = keyof typeof dict;

let current: Lang = (() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'it') return saved;
  } catch { /* storage bloccato (iframe portali): default EN */ }
  return 'en';
})();

export function getLang(): Lang {
  return current;
}

export function setLang(lang: Lang): void {
  current = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch { /* best effort */ }
}

export function t(key: I18nKey, vars?: Record<string, string | number>): string {
  let out: string = dict[key][current];
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replace(`{${k}}`, String(v));
  return out;
}
